"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var StringPrinter_1 = require("../components/StringPrinter");
var ReactComponentPrinter_1 = require("../components/ReactComponentPrinter");
var SelectorPrinter_1 = require("../components/SelectorPrinter");
var ReactPrintTool = function () {
  function ReactPrintTool() {
    var _this = this;
    this._getContainer = function () {
      if (_this._container === undefined) {
        var element = document.createElement("div");
        element.className = "print-wrapper";
        _this._container = document.body.appendChild(element);
      }
      return _this._container;
    };
    this.printFromReactComponent = function (component) {
      react_dom_1.default.render(react_1.default.createElement(ReactComponentPrinter_1.ReactComponentPrinter, {
        component: component,
        unMount: _this._unMount
      }), _this._getContainer());
    };
    this.printFromString = function (html) {
      react_dom_1.default.render(react_1.default.createElement(StringPrinter_1.StringPrinter, {
        html: html,
        unMount: _this._unMount
      }), _this._getContainer());
    };
    this.printExistingElement = function (selector) {
      react_dom_1.default.render(react_1.default.createElement(SelectorPrinter_1.SelectorPrinter, {
        querySelector: selector,
        unMount: _this._unMount
      }), _this._getContainer());
    };
    this._unMount = function () {
      if (_this._container !== undefined) {
        react_dom_1.default.unmountComponentAtNode(_this._container);
      }
    };
  }
  return ReactPrintTool;
}();
exports.ReactPrintTool = ReactPrintTool;